import {
  Switch as MantineSwitch,
  SwitchProps as MantineSwitchProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Switch.module.css';

export type SwitchSize = 'xl' | 'md';

export interface SwitchProps extends Omit<
  MantineSwitchProps,
  | 'variant'
  | 'color'
  | 'styles'
  | 'classNames'
  | 'style'
  | 'size'
  | 'radius'
  | 'readOnly'
> {
  size?: SwitchSize;
  isReadOnly?: boolean;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ size = 'md', isReadOnly, ...props }, ref) => {
    return (
      <MantineSwitch
        ref={ref}
        unstyled
        classNames={{
          root: styles.root,
          track: styles.track,
          thumb: styles.thumb,
          input: styles.input,
          body: styles.body,
          labelWrapper: styles.labelWrapper,
          label: styles.label,
          description: styles.description,
          error: styles.error,
        }}
        wrapperProps={{ 'data-input-size': size }}
        readOnly={isReadOnly}
        {...props}
      />
    );
  }
);

Switch.displayName = 'Switch';
